<template>
  <footer class="footer" v-if="$store.state.contacts">
    <div class="footer__container">
      <div class="footer__column">
        <a class="footer__link" :href="`mailto:${$store.state.contacts.email}`" :title="$store.state.contacts.email" v-if="$store.state.contacts.email">{{ $store.state.contacts.email }}</a>
        <a class="footer__link" :href="`tel:${$store.state.contacts.phone}`" :title="$store.state.contacts.phone" v-if="$store.state.contacts.phone">{{$store.state.contacts.phone }}</a>
<!--        <a target="_blank" rel="nofollow" class="footer__social" :href="`//instagram.com/${$store.state.contacts.instagram}`" title="Instagram" aria-label="Instagram" v-if="$store.state.contacts.instagram">-->
<!--          <i class="footer__social__icon" aria-hidden="true">-->
<!--            <instagram-icon/>-->
<!--          </i>-->
<!--        </a>-->
        <a target="_blank" rel="nofollow" class="footer__social" :href="`//vk.com/${$store.state.contacts.vk}`" title="VK" aria-label="VK" v-if="$store.state.contacts.vk">
          <i class="footer__social__icon" aria-hidden="true">
            <vk-icon/>
          </i>
        </a>
        <a target="_blank" rel="nofollow" class="footer__social" :href="`//t.me/${$store.state.contacts.facebook}`" v-if="$store.state.contacts.facebook" title="Telegram" aria-label="Telegram">
          <i class="footer__social__icon" aria-hidden="true">
            <telegram-icon/>
          </i>
        </a>
      </div>
      <div class="footer__column">
        <router-link :to="{ name: 'apply' }" class="footer__button" title="Обращение к руководителю" aria-label="Обращение к руководителю">
          <span class="footer__button__text">Обращение к руководителю</span>
          <i class="footer__button__icon" aria-hidden="true">
            <arrow-icon/>
          </i>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
// import InstagramIcon from './svg/InstagramIcon.vue'
import TelegramIcon from './svg/TelegramIcon.vue'
import VkIcon from './svg/VkIcon.vue'
import ArrowIcon from './svg/ArrowIcon.vue'

export default {
  name: 'FooterComponent',
  components: { VkIcon, TelegramIcon, ArrowIcon }
}
</script>
